export default __webpack_public_path__ + "static/m-customer2-fefe0b850d54975757babf979f63934c.png";